import { createAsyncThunk } from '@reduxjs/toolkit';
import { StatsCategoryProps } from 'Douleutaras/redux/data/stats/types';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { JSONApiDataObject } from 'Douleutaras/types';

const STATS_PROS_SCORE_API = 'api/public/v3/stats/pros-score';

export enum ScoreTier {
  BAD = 'bad',
  SATISFACTORY = 'satisfactory',
  GOOD = 'good'
}

export interface ProsScore {
  proScore: number; // 0 - 1
  scoreTier: ScoreTier;
  scoreRanges: Array<{
    start: number;
    end: number;
    scoreTier: ScoreTier
  }>;
}

const prosScoreMap: Map<string, Array<ProsScore>> = new Map();

export const getProsScore = createAsyncThunk<JSONApiDataObject<ProsScore>, StatsCategoryProps>(
  'stats/prosScore/get',
  async ({ catId, subCatId }, api) => {
    const request = `${STATS_PROS_SCORE_API}/${catId}/${subCatId}`;
    if (!prosScoreMap.has(request)) {
      const response = await makeRequest(
        request,
        {
          method: 'GET'
        }
      )(api);
      prosScoreMap.set(request, response.data.data);

      return response.data.data;
    } else {
      return prosScoreMap.get(request);
    }
  }
);
